import { useMutation, useQueryClient } from "@tanstack/react-query";
import { leagueRepository } from "@/config/dataSource";
import { leaguesQueryKeys } from "@/modules/leagues/hooks/useLeagues";
import type { CreateLeagueInput } from "@/modules/leagues/repositories/LeagueRepository";

export function useCreateLeague() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateLeagueInput) => leagueRepository.createLeague(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leaguesQueryKeys.all });
    },
  });
}
